/*
 * @Author: shuchang
 * @Date: 2021-09-15 10:52:01
 * @LastEditors: shuchang
 * @LastEditTime: 2021-09-15 10:54:38
 * @Description: 
 */

let baseApiUrl = "http://api.dev.guojutech.net";
if (process.env.NODE_ENV != 'development') {
    let env = require('../config/env');
    baseApiUrl = env.API_URL;
}

// export const BaseUrl =  baseApiUrl + '/jyxm-boss';
export const API_URL =  baseApiUrl;
// export const BaseUrl = process.env.BASE_URL;